module.exports = ".line-container {\n  height: 300px;\n  width: 100%;\n  display: block; }\n\n.gauge-container {\n  height: 300px;\n  width: 100%;\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.scss
// module id = ./src/app/dashboard/dashboard.component.scss
// module chunks = dashboard.module